<template>
    <div class="biometrics-summary">

        <div class="container biometrics-summary__row">
            <b-row :cols="$mq == 'sm' ? 3 : 6">
                <b-col v-for="(cell,j) in cells" :key="j">
                    <div class="header-cell"
                         :class="{'missing-value': !cell.value}">
                        {{ cell.label }}
                    </div>
                    <div class="value-cell"
                         v-if="showValues"
                         :class="{'missing-value': !cell.value}">
                        {{ cell.value ? cell.value : '&nbsp;' }}
                    </div>
                </b-col>
            </b-row>
        </div>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * A minimalist view showing the values for a Biometrics record
 */
export default Vue.extend({
    name: 'BiometricsSummary',
    props: {
        biometrics: Object,
        showValues: {type: Boolean, default: false}
    },
    computed: {
        cells() {
            return [
                {label: 'TC', value: this.biometrics.tchol},
                {label: 'LDL', value: this.biometrics.ldl_c},
                {label: 'HDL', value: this.biometrics.hdl_c},
                {label: 'TRIG', value: this.biometrics.trig},
                {label: 'FBG', value: this.biometrics.fasting_bg},
                {label: 'A1C', value: this.biometrics.a1c},
            ]
        }
    },
})

</script>

<style lang="scss">
.biometrics-summary {
    .header-cell {
        width: 100%;
        min-width: 50px;
        text-align: center;
        background-color: var(--base-color-lighten-30);
        padding-top: 8px;
        padding-bottom: 8px;

        &.missing-value {
            background-color: #ddd;
            color: #999;
        }
    }

    .value-cell {
        width: 100%;
        min-width: 50px;
        text-align: center;
        background-color: transparent;
        border: solid 1px var(--base-color-lighten-30);
        padding-top: 8px;
        padding-bottom: 8px;

        &.missing-value {
            border-color: #ddd;
        }
    }
}

.biometrics-summary__row {
    &:first-child {
        padding-bottom: 1em;
    }
}

</style>
